// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cpaas-navbar{z-index:1026;background-color:#0C0E1C;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif}a.cpass-nav-link.override-link-style,a.cpass-nav-link.override-link-style:focus,a.cpass-nav-link.override-link-style:active:focus{color:#FFFFFF;text-decoration:none;font-size:.875rem}", ""]);
// Exports
module.exports = exports;
